export const DEFAULT_SUCCESS_TITLE = '¡Bien echo!';
export const DEFAULT_SUCCESS_MESSAGE = 'El proceso finalizó exitosamente';
export const DEFAULT_ERROR_TITLE = 'Error';
export const DEFAULT_ERROR_MESSAGE =
  'Hubo un error en el proceso. Intenta nuevamente.';
